import type { AgingBucket } from '@order-pilot/shared';

/** "Today", "Yesterday", "12 days ago" — how long since [days] ago, in words. */
export function agingText(days: number | null): string {
  if (days === null) return '—';
  if (days === 0) return 'Today';
  if (days === 1) return 'Yesterday';
  return `${days} days ago`;
}

/** The filter chips on the Customers page, in the order they read. */
export const AGING_FILTERS: ReadonlyArray<{ id: 'all' | AgingBucket; label: string }> = [
  { id: 'all', label: 'All' },
  { id: 'recent', label: 'Last 7 days' },
  { id: 'month', label: '8–30 days' },
  { id: 'quarter', label: '31–90 days' },
  { id: 'lapsed', label: 'Over 90 days' },
];

// Literal class names (not template strings) so Tailwind keeps them in the build.
const BUCKET_CLASS: Record<AgingBucket, string> = {
  recent: 'text-emerald-700',
  month: 'text-slate-700',
  quarter: 'text-amber-700',
  lapsed: 'text-red-700',
};

/** "12 days ago", coloured by how overdue the customer is for a visit. */
export function AgingText({ days, bucket }: { days: number | null; bucket: AgingBucket | null }) {
  if (days === null || bucket === null) return <span className="text-slate-400">—</span>;
  return <span className={`whitespace-nowrap font-medium ${BUCKET_CLASS[bucket]}`}>{agingText(days)}</span>;
}
